import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Switch,
  TextField,
} from '@mui/material'
import React from 'react'

const CustomFieldFilter = ({ handleFilterChange, customField, filters }) => {
  const key = `CUSTOM-${customField.id}`
  const value = filters[key] || ''
  const label = customField.name

  if (customField.typeId === 1)
    return (
      <TextField
        margin={'dense'}
        fullWidth
        label={label}
        value={value}
        onChange={(e) => handleFilterChange(key, e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>{'(Includes)'}</InputAdornment>
          ),
        }}
      ></TextField>
    )

  if (customField.typeId === 2) {
    return (
      <FormControl>
        <FormHelperText>{label}</FormHelperText>

        <Box sx={{ display: 'flex' }}>
          <TextField
            type={'number'}
            value={filters[key + '-min'] || ''}
            onChange={(e) => handleFilterChange(key + '-min', e.target.value)}
            label={'Min'}
          ></TextField>
          <TextField
            type={'number'}
            value={filters[key + '-max'] || ''}
            onChange={(e) => handleFilterChange(key + '-max', e.target.value)}
            label={'Max'}
          ></TextField>
        </Box>
      </FormControl>
    )
  }

  if (customField.typeId === 3) {
    return (
      <FormControlLabel
        label={label}
        control={
          <Switch
            checked={value}
            onChange={(e) => handleFilterChange(key, e.target.checked)}
          />
        }
      ></FormControlLabel>
    )
  }

  if (customField.typeId === 4 || customField.typeId === 5) {
    return (
      <TextField
        margin='normal'
        fullWidth
        label={label}
        value={value}
        onChange={(e) => handleFilterChange(key, e.target.value)}
        select
      >
        <MenuItem value={null}>All</MenuItem>
        {customField.options.map((o, i) => (
          <MenuItem key={`custom-${i}`} value={o.id}>
            {o.name}
          </MenuItem>
        ))}
      </TextField>
    )
  }
}

export default CustomFieldFilter
